// src/init/tasks.js
// Each task: async ({ signal, context }) => void
// - signal: for aborting long work if needed
// - context: a mutable bag you can pass data between tasks (e.g., auth result)

import { db } from "../db/dexie"; // or wherever you export your Dexie instance
import { verifyServiceWorker } from "./utils"; // stubbed below

/*
“Other recommended checks” you can snap in if they help your PWA:
- Clock skew detector: compare server Date header to Date.now(); warn if > ±5 minutes.
- Local storage & IDB quota: call navigator.storage.estimate() to ensure ≥ a threshold.
- Feature flags / remote config: prefetch a small JSON to influence initial route or UI.
- Network state: snapshot navigator.onLine and register listeners early.
- DB migrations: if you version stores per feature, run a lightweight smoke read/write.
- First-run sentinel: if no settings.firstRunComplete, route to onboarding.
*/
const tasks = [
  /** Initialize Database
   *
   * Database Initialization occurs in DexieProvider
   *
   * Therefore database initialization should be complete before other AppBootstrap tasks need it
   */
  /** Initialize Theme
   *
   * Theme Initialization occurs in ThemeProvider and ThemeSync
   */

  // {
  // name: "Initialize database",
  // fatal: true, // if DB fails, we can't proceed
  // run: async ({ signal }) => {
  //   // Ensure schema exists and DB is open; Dexie open() is idempotent.
  //   await db.open(); // throws if blocked/denied
  //   // Optional: smoke test
  //   await db.transaction("r", db.tables, async () => void 0);
  // },
  // },
  // no longer needed since ThemeProvider handles all Theme setup before AppBootstrap
  // {
  //   name: "Initialize theme",
  //   fatal: false,
  //   run: async ({ context }) => {
  //     context.theme = await bootstrapTheme(db); // read persisted theme, apply class, etc.
  //   },
  // },
  {
    name: "Service Worker / offline readiness",
    fatal: false, // ✅ never block boot
    run: async () => {
      try {
        // Do not let this hang
        const res = await verifyServiceWorker({ timeoutMs: 1500 });
        // Optional: log for diagnostics
        if (!res.ok) console.info("SW check:", res.reason);
      } catch {
        /* ignore */
      }
    },
  },

  //   {
  //     name: "Authentication check",
  //     fatal: false, // let app load unauthenticated
  //     run: async ({ context }) => {
  //       // e.g., try refresh; store result for AuthProvider to consume if you wire it that way
  //       context.auth = await pingAuth(); // { isAuthenticated, user? }
  //     },
  //   },
  //   {
  //     name: "Service Worker / offline readiness",
  //     fatal: false,
  //     run: async () => {
  //       await verifyServiceWorker(); // no-op OK in dev
  //     },
  //   },
  // Add more:
  // - feature flags fetch
  // - clock skew check
  // - storage quota check
  // - remote config prefetch
];

export async function runInitTasks({ onUpdate }) {
  const controller = new AbortController();
  const signal = controller.signal;
  const context = {};

  onUpdate?.({ type: "start", total: tasks.length });

  for (let i = 0; i < tasks.length; i++) {
    const t = tasks[i];
    try {
      onUpdate?.({ type: "step", index: i, name: t.name });
      console.log(t.name);
      await t.run({ signal, context });
    } catch (e) {
      if (t.fatal) throw e;
      // Non-fatal: log and continue
      console.warn(`Init warning (${t.name}):`, e);
    }
  }

  onUpdate?.({ type: "done" });
  return context;
}
